import {
  FromFilterDefinition,
  NonNullableFilterValues,
  NullableFilterValues,
} from '../filtering';

export const CLIENT_FILTER_DEFINITION = {
  search: 'string',
} as const;

export type ClientFilterDefinition = FromFilterDefinition<
  typeof CLIENT_FILTER_DEFINITION
>;

export type NullableClientFilter = NullableFilterValues<ClientFilterDefinition>;
export type NonNullableClientFilter =
  NonNullableFilterValues<ClientFilterDefinition>;

export const DEFAULT_CLIENT_FILTER: NullableClientFilter = {
  search: null,
};
